import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const client = axios.create({
    baseURL: API_BASE,
    headers: { "Content-Type": "application/json" },
    timeout: 20000,
});

export const api = {
    getSiteConfig: () => client.get("/site-config").then((r) => r.data),
    createBooking: (payload) =>
        client.post("/bookings", payload).then((r) => r.data),
    createQuote: (payload) =>
        client.post("/quote", payload).then((r) => r.data),
    createContact: (payload) =>
        client.post("/contact", payload).then((r) => r.data),
};

export default client;
